import {connect} from '@modifi/redux'
import {compose} from 'ramda'
import {aShowDialog, aCloseDialog, aUpdateDialogData} from '@modifi/plugin-dialogs'
import {aPush} from '@modifi/router'

import {DIALOG_EXIT_PROMPT} from '../../dialogs'

import NavigationHook from './NavigationHook'

const mapStateToProps = null

const mapDispatchToProps = {
  showDialog: (params: any): any => aShowDialog(DIALOG_EXIT_PROMPT, params),
  closeDialog: aCloseDialog,
  redirect: aPush,
  updateDialogData: (data: any): any => aUpdateDialogData(DIALOG_EXIT_PROMPT, data),
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(NavigationHook)
